const OPENS_IN_NEW_WINDOW_PATTERN = /opens in new (window|tab)/i;

export const DEFAULT_OPENS_IN_NEW_WINDOW_ARIA = 'opens in new window';

/**
 * Appends a new-window phrase to a link aria-label (WCAG 3.2.2 / G201).
 * Skips when the label already mentions a new window/tab.
 */
export function appendOpensInNewWindowAriaLabel(
  label: string | undefined,
  options?: { opensInNewTab?: boolean; suffix?: string }
): string | undefined {
  const { opensInNewTab = false, suffix = DEFAULT_OPENS_IN_NEW_WINDOW_ARIA } = options ?? {};
  const trimmed = label?.trim();
  if (!trimmed || !opensInNewTab) {
    return label;
  }
  if (OPENS_IN_NEW_WINDOW_PATTERN.test(trimmed)) {
    return trimmed;
  }
  return `${trimmed}, ${suffix}`;
}
